import { MaskLines } from "../../lib/motion";

// Consistent inner-page header with the fixed-header offset built in.
export const PageHero = ({ overline, titleLines, intro }) => (
  <section className="container-x pt-36 md:pt-52 pb-16 md:pb-24" data-testid="page-hero">
    {overline && <p className="overline text-bronze mb-8">{overline}</p>}
    <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-5xl">
      <MaskLines lines={titleLines} />
    </h1>
    {intro && (
      <p className="mt-10 max-w-2xl text-lg font-light leading-relaxed text-olive">{intro}</p>
    )}
  </section>
);
